import React, { useEffect } from "react";
import {
  LegalType,
  LegalTypeOptions,
} from "../../../../hooks/useLandlordSelect";
import "styles/components/Dashboard/PropertyLandlordSelect.scss";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import { UserOutlined } from "@ant-design/icons";
import { Icon } from "@iconify/react";
import { LegalTypeRadioSelectProps } from "js/components/Landlords/types";

export const LegalTypeRadioSelect: React.FC<LegalTypeRadioSelectProps> = ({
  defaultValue,
  handleToggle,
}) => {
  const screen = useBreakpoint();
  const [selected, setSelected] = React.useState<LegalType>(defaultValue);

  const style = {
    width: "100%",
    display: "flex",
    justifyContent: "start",
    flexDirection: "column",
    marginLeft: !screen.lg ? null : "20px",
    marginBottom: "20px",
  };

  const availableOptions: LegalTypeOptions = {
    pf: {
      type: "pf",
      name: "Persona Física",
      description: "Individuos con RFC e identificación oficial",
      icon: <UserOutlined />,
    },
    pm: {
      type: "pm",
      name: "Persona Moral",
      description: "Empresas, asociaciones o entidades legales",
      icon: (
        <Icon style={{ marginTop: "8px" }} icon="octicon:organization-24" />
      ),
    },
  };

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  return (
    <div className="container" style={style}>
      <p style={{ fontWeight: "bold" }}>
        Elige qué tipo de persona quieres registrar:
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: !screen.lg ? "column" : "row",
          gap: 20,
        }}
      >
        {Object.values(availableOptions).map((option) => (
          <div
            key={option.type}
            onClick={() => {
              handleToggle(option.type);
              setSelected(option.type);
            }}
            className={`option ${selected === option.type ? "selected" : "default"}`}
            style={{
              width: !screen.lg ? "100%" : "31%",
              display: "flex",
              justifyContent: "start",
            }}
          >
            <span
              className={`dot ${selected === option.type ? "selected" : "default"}`}
            >
              {selected === option.type && <span className="inner-dot" />}
            </span>

            <span className="icon">{option.icon}</span>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span className="name" style={{ fontWeight: "bold" }}>
                {option.name}
              </span>
              <span className="name">{option.description}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
